import { CSSProperties, useState } from "react";

export interface LoadedImageProps {
	src?: string;
	alt?: string;
	className?: string;
	style?: CSSProperties;
	onClick?: () => void;
}

/**
 * Renders a network image; renders nothing (no fallback) if `src` is absent
 * or fails to load — e.g. a branding logo whose backend SAS URL has expired.
 */
const LoadedImage: React.FC<LoadedImageProps> = ({ src, alt = "", className, style, onClick }) => {
	const [failed, setFailed] = useState(false);

	if (!src || failed) return null;

	return (
		<img src={src} alt={alt} className={className} style={style} onClick={onClick} onError={() => setFailed(true)} />
	);
};

export default LoadedImage;
